import { UserKazaplanServiceProduct, UserKazaplanServiceService } from '@adeo/ngx-kozikaza-api/payment';
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  LOCALE_ID,
  NgZone,
  OnDestroy,
  OnInit,
  Optional,
  PLATFORM_ID,
  Renderer2, ViewChild,
} from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { kzIconsCross } from '../../kz-ui/ui/icon/generated-icons/kzIcons-cross.icon';
import { KzIconsRegistryService } from '../../kz-ui/ui/icon/kz-icons-registry.service';
import { KzModalService } from '../../kz-ui/ui/modal/kz-modal.service';
import { MediaQueriesService } from '../../shared/services/utilities/media-queries.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { RoutesService } from '../../shared/services/routes/routes.service';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { BehaviorSubject, EMPTY, from, merge, NEVER, Observable, Subject, Subscription, zip } from 'rxjs';
import {
  convertIRItoID,
  distinctHydraMember,
  filterNullOrUndefined,
  filterUndefined,
  Media,
  Professional,
  TokenStorage,
  User,
} from '@adeo/ngx-kozikaza-api';
import { of } from 'rxjs/internal/observable/of';
import { environment } from 'environments/environment';
import { UserStoreService } from '../../shared/services/state-management/user-store.service';
import { LocalizedRouterService } from '../../shared/services/localized-router.service';
import { AuthService } from '../auth/auth.service';
import { AuthService as LegacyAuthService } from '../../shared/services/features/oauth/auth.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { ToastrService } from '../../shared/services/utilities/toastr.service';
import { DataLayerService, GAEventAction } from '../../shared/services/utilities/data-layer.service';
import { KazaService as LegacyKazaService } from '../../shared/services/features/kaza/kaza.service';
import { TokywokyService } from '../../shared/services/utilities/tokywoky.service';
import { KzpService } from '../../shared/services/utilities/kzp.service';
import { KozikashService } from '../kozikash/kozikash.service';
import { KazaplanMenuPlanComponent } from './kazaplan-menu-plan/kazaplan-menu-plan.component';
import { KazaplanService } from './kazaplan.service';
import { DateService } from '../../shared/services/utilities/date.service';
import { fadeInAnimation } from 'src/app/shared/animations/fade-in.animation';
import { TranslateStore } from '@ngx-translate/core';
import { ModalePlanArea } from 'src/app/utils/const/deals';
import { KazaPlanService } from '@adeo/ngx-kozikaza-api/kazaplan';

@Component({
  selector: 'app-kazaplan',
  templateUrl: './kazaplan.component.html',
  styleUrls: ['./kazaplan.component.scss'],
  animations: [fadeInAnimation],
  providers:[KazaPlanService]
})
export class KazaplanComponent implements OnInit, OnDestroy {
  private unsubscribe$: Subject<void> = new Subject<void>();
  public browserIsValid = false;
  private shortCuts = {a: null, b: null};
  public planId = null;
  public kazaplanInstance = null;
  private exitUrl = null;
  private plannerMode = null;
  private skipAlertMessageOnExit = false;
  public config: any = {
    locale: 'fr-FR',
    env: environment.KAZAPLAN_ENV,
    environment: environment.KAZAPLAN_ENVIRONMENT,
    appId: undefined,
    partnerKey: undefined,
    mode: 'new',
    buttons: {
      screenshotByPartner: true,
    },
    plan: {
      id: this.planId,
      mode: this.plannerMode,
    },
    kazaFirstPlan: true,
  };

  planNew = false;
  planSaved = false;

  scriptLoaded = false;
  private subscription: Subscription;
  private createPlanSubscriber: Subscription;
  private projectSubscription: Subscription;
  userLoggedIsAdmin = false;
  private previousEvent: string = null;
  private tokySub: Subscription;

  adLocation = ModalePlanArea;
  adLocationSettings = {
    closeTrackingPixel: 'https://tinykozi.io/img_ff60224',
    noMoreTrackingPixel: 'https://tinykozi.io/img_1e3696b',
    width: 300,
    height: 250,
    transition: 'slideUp',
    delay: (this.translateStore.translations[this.locale]?.api?.ads?.plan_modal !== null) ? this.translateStore.translations[this.locale]?.api?.ads?.plan_modal : 1000,
  };

  public kitchen = $localize`:@@pro.tender.projects.val26:3D plan - We design your plan for you - 29€`;
  delay: number;

  private _kitchenPriceEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public kitchenPriceEnabled$: Observable<boolean> = this._kitchenPriceEnabled$.asObservable();
  private _moodWindowOpened$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public moodWindowOpened$: Observable<boolean> = this._moodWindowOpened$.asObservable();

  public isPlanEditableByKozikash: boolean = true;
  public isSubscriptionRequiredByKozikash: boolean = false;
  public isReadOnlyModalClosed = false;
  @ViewChild('kzpMenuPlan') kzpMenuPlan: KazaplanMenuPlanComponent;
  public isPremium = false;

  constructor(
    protected activatedRoute: ActivatedRoute,
    public mediaQueriesService: MediaQueriesService,
    private routesService: RoutesService,
    @Inject(DOCUMENT) private doc: any,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(LOCALE_ID) public locale: string,
    @Optional() @Inject('DEFAULT_COUNTRY') private readonly country,
    private renderer: Renderer2,
    private router: Router,
    private cdr: ChangeDetectorRef,
    public readonly userStoreService: UserStoreService,
    private readonly localizedRouterService: LocalizedRouterService,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly authService: AuthService,
    private legacyAuthService: LegacyAuthService,
    private toastrService: ToastrService,
    private dataLayerService: DataLayerService,
    private kazaService: LegacyKazaService,
    private ngZone: NgZone,
    private tokywokyService: TokywokyService,
    private kzpService: KzpService,
    private kazaplanService: KazaplanService,
    private dateService: DateService,
    private tokenStorage: TokenStorage,
    private translateStore: TranslateStore,
    private readonly userKazaplanServiceService: UserKazaplanServiceService,
    private readonly kzIconsRegistryService: KzIconsRegistryService,
    private readonly kzModalService: KzModalService,
    private readonly kozikashService: KozikashService,
    private kazaPlanService:KazaPlanService
  ) {
    kzIconsRegistryService.registerIcons([kzIconsCross]);
  }

  ngOnInit(): void {
    this.loadAuthModule();

    if (!this.mediaQueriesService.detectIE() && isPlatformBrowser(this.platformId)) {
      this.browserIsValid = true;
      this.planId = this.activatedRoute.snapshot.params.planId || null;
      this.plannerMode = this.activatedRoute.snapshot.params.mode;
      this.config = Object.assign(this.config, {locale: this.locale, plan: {id: this.planId, mode: this.plannerMode}});
      const currentTranslatedPathTemplate = this.extractTemplateFromRouter(this.router);

      Sentry.addBreadcrumb({
        category: 'console',
        message: 'Kzp cmp > NgOnInit > currentLangKazaplanNewPath > locale : ' + this.locale,
        level: 'info',
      });

     /* this.kozikashService.lookForPremiumProduct()
        .pipe(
          finalize(() => {
            this.cdr.detectChanges();
          }),
          tap((userKazaplanServiceProduct: UserKazaplanServiceProduct) => {
            if (userKazaplanServiceProduct) {
              this.isPremium = userKazaplanServiceProduct.endSubscriptionDate === null || new Date(userKazaplanServiceProduct.endSubscriptionDate).getTime() >= (Date.now() - 1000);
            }
          }),
        )
        .subscribe();*/

      this.subscription = this.localizedRouterService.translatePath('/kazaplan/new/:planId', this.locale).pipe(
        switchMap((currentLangKazaplanNewPath) => {
          currentLangKazaplanNewPath = currentLangKazaplanNewPath;

          Sentry.addBreadcrumb({
            category: 'console',
            message: 'Kzp cmp > ngOnInit > currentLangKazaplanNewPath > ' + currentLangKazaplanNewPath,
            level: 'info',
          });

          const obs = [];
          if (this.planId !== null) {
            this.config.mode = (currentLangKazaplanNewPath === currentTranslatedPathTemplate) ?
              'template' : 'edit';

            obs.push(this.loadPlan());

            Sentry.addBreadcrumb({
              category: 'console',
              message: 'Kzp cmp > ngOnInit > this.kazaplanState.mode > ' + this.config.mode,
              level: 'info',
            });
          }

          if (this.config.mode === 'new' && isPlatformBrowser(this.platformId)) {
            this.doc.body.classList.add('kz-app-kazaplan');
            obs.push(this.loadUser());
          }

          return obs.length ? merge(...obs) : EMPTY;
        }),
        switchMap((result) => {
          if (this.config.mode == 'new') {
            return this.userKazaplanServiceService.getPlansCreatable({refresh: true})
              .pipe(
                tap(planCreatable => {
                  this.isSubscriptionRequiredByKozikash = !planCreatable.canCreatePlan;
                  this.cdr.detectChanges();
                }),
              );
          }

          if (this.config.mode == 'edit') {
            return this.userKazaplanServiceService.getPlansEditable(this.config.plan.id, {refresh: true})
              .pipe(
                tap(planEditable => {
                  this.isPlanEditableByKozikash = planEditable.canEditPlan;
                  console.log(
                    'Plan Editable',
                    this.config.mode,
                    planEditable,
                    {
                      isPlanEditableByKozikash: this.isPlanEditableByKozikash,
                      isSubscriptionRequiredByKozikash: this.isSubscriptionRequiredByKozikash,
                    },
                    {
                      isPlanEditableByKozikash: !planEditable.canEditPlan,
                    },
                  );

                 // this.config.mode = this.isPlanEditableByKozikash ? this.config.mode : 'viewer';
                  this.cdr.detectChanges();
                }),
              );
          }

          return of(result);
        })).subscribe(
        () => {
          this.initApp();
          this.loadScript();
        },
      );
    } else {
      this.browserIsValid = false;
      Sentry.captureException(new Error('Kzp cmp > Try to open plan from IE detected'));
    }

    this.tokySub = this.mediaQueriesService.isDesktop()
      .pipe(
        tap(() => this.tokywokyService.initTokyWoky()),
      ).subscribe();
  }

  loadScript() {
    if (this.scriptLoaded) {
      return;
    }
    this.scriptLoaded = true;

    const loadScript = require('simple-load-script');
    loadScript(environment.KAZAPLAN_SCRIPT + '?no-cache=' + new Date().getTime())
      .then(() => {
      });
  }

  initApp() {
    if (this.config.partnerKey === undefined) {
      const partnerKey = this.kzpService.getPartnerKeyFromCookie();
      this.config = {
        ...this.config,
        partnerKey,
        appId: this.kzpService.getAppIdFromPartnerKey(partnerKey),
      };
    }
    window['kzpAsyncInit'] = () => {

      window['KZP'].init('#kazaplan', {
        ...this.config,
        onReady: (app) => {
          this.kazaplanInstance = app;
        },
        onRequestLogout: (callback) => {
          this.legacyAuthService.logout();
          this.router.navigate(this.localizeRouterService.translateRoute(['/kazacafe']) as string[]);
          callback();
        },
        onRequestAuthentication: ({authenticate}) => {
          this.ngZone.run(() => {
            this.router.navigate([{
              outlets: {
                auth: ['authentification', 'login'],
              },
            }]);
          });
          this.userStoreService.userStore.pipe(
            filterNullOrUndefined(),
            distinctHydraMember(),
          )
            .subscribe((user) => {
              authenticate({
                token: this.tokenStorage.token.accessToken,
                avatar: user.avatar
                  ? (user.avatar as Media).thumbs.small
                  : environment.REDIRECT_URL + '/assets/images/register/virgin_profile.png',
                username: user.username,
              });
              this.planNew = false;
              this.planSaved = true;
              this.cdr.detectChanges();
            });
        },
        onEvent: (app, eventName, status, data) => {
          this.previousEvent = eventName;
          Sentry.configureScope(scope => scope.setTag('handleKazaplanEvents', eventName + ' ' + status));
          this.handleKazaplanEvents(app, eventName, status, data);
          // if (this.kzpMenuPlan) {
          //   this.kzpMenuPlan.load();
          // }
        },
      });
    };
  }

  handleKazaplanEvents(app, eventName, status, data) {
    switch (eventName) {
      case 'newPlan':
      case 'templatePlan':
        this.handleNewPlanEvents(status, data);
        break;
      case 'editPlan':
        this.handleEditPlanEvents(status, data);
        break;
      case 'duplicatePlan':
        this.handleDuplicatePlanEvents(status, data);
        break;
      case 'migratePlan':
        this.handleMigratePlansEvents(status, data);
        break;
      case 'kitchenPriceEnabled':
        this._kitchenPriceEnabled$.next(true);
        this.cdr.detectChanges();
        break;
      case 'kitchenPriceDisabled':
        this._kitchenPriceEnabled$.next(false);
        this.cdr.detectChanges();
        break;
      case 'moodWindowOpened':
        this._moodWindowOpened$.next(true);
        this.cdr.detectChanges();
        break;
      case 'moodWindowClosed':
        this._moodWindowOpened$.next(false);
        this.cdr.detectChanges();
        break;
      case 'quitPlan':
        this.handleQuitePlanEvents(status, data);
        break;
    }
  }

  handleNewPlanEvents(status, data) {
    if (status === 'start') {
      this.planNew = true;
      this.planSaved = false;
      this.skipAlertMessageOnExit = false;
      this.cdr.detectChanges();
      this.resetPlan();
    } else if (status === 'saveSuccess') {
      this.savePlan(data?.id, data?.title, data?.projectId, null);
    } else if (status === 'saveError') {
      Sentry.captureException(new Error('Kzp cmp > saveError'));
    } else if (status === 'starterScreen' || status === 'starterscreen') {
      if (this.config.mode !== 'edit') {
        this.resetPlan();
      }
    }
  }

  handleEditPlanEvents(status, data) {
    if (status === 'saveSuccess') {
      this.savePlan(data.id, data.title, data.projectId, null);
    } else if (status === 'newPlanSave' || status === 'newPlanNoSave') {
      this.resetPlan();
      this.skipAlertMessageOnExit = false;
    } else if (status === 'loaded') {
      this.planNew = false;
      this.planSaved = true;
      this.cdr.detectChanges();
      if (this.config.mode === 'template') {
        const newPath = (this.localizeRouterService.translateRoute(['kazaplan', 'new']) as string[]).join('/');
        this.planId = data.id;
        window.history.pushState({}, null, newPath);
      } else if (this.config.mode !== 'template' && !this.plannerMode) {
        const editPath = (this.localizeRouterService.translateRoute(['kazaplan', data.id, 'edit']) as string[]).join('/');
        this.planId = data.id;
        window.history.pushState({}, null, editPath);
      }
    } else if (status === 'saveError') {
      Sentry.captureException(new Error('Kzp cmp > Edit plan > saveError'), {extra: {id: data.id, title: data.title}});
    }
  }

  handleDuplicatePlanEvents(status, data) {
    this.skipAlertMessageOnExit = false;
    if (status === 'saveSuccess') {
      this.savePlan(data.id, data.title, data.projectId, null);
    } else if (status === 'saveError') {
      Sentry.captureException(new Error('Kzp cmp > Duplicate > saveError'), {extra: {id: data.id, title: data.title}});
    }
  }

  handleQuitePlanEvents(status, data) {
    if (status === 'quitSaveSuccess' || status === 'saveSuccess') {
      this.skipAlertMessageOnExit = true;
      this.savePlan(data.id, data.title, data.projectId, data.redirectUrl);
    } else if (status === 'quitNoSave') {
      this.skipAlertMessageOnExit = true;
      this.exitPlan(data.redirectUrl);
    } else if (status === 'quitCancel' || status === 'quitSaveError' || status === 'unauthorized') {
      this.skipAlertMessageOnExit = false;
    } else if (status === 'saveError') {
      Sentry.captureException(new Error('Kzp cmp > Quite > saveError'), {extra: {id: data.id, title: data.title}});
    }
  }

  handleMigratePlansEvents(status, data) {
    if (status === 'error') {
    } else if (status === 'success') {
      this.savePlan(data.id, data.title, data.projectId, null);
    } else if (status === 'start') {
      this.migratePlan();
    }
  }

  migratePlan() {
    Sentry.configureScope(scope => scope.setTag('action', 'newPlanClick'));
    if (isPlatformBrowser(this.platformId)) {
      window.history.pushState({}, null, `${(this.localizeRouterService.translateRoute(['kazaplan', 'new']) as string[]).join('/')}`);
    }
  }

  resetPlan() {
    Sentry.configureScope(scope => scope.setTag('action', 'newPlanClick'));
    if (isPlatformBrowser(this.platformId)) {
      window.history.pushState({}, null, `${(this.localizeRouterService.translateRoute(['kazaplan', 'new']) as string[]).join('/')}`);
    }
  }

  initUser(user: User): Observable<any> {
    if (user) {
      // Define PartnerKey
      const partnerKey = this.kzpService.getPartnerKeyFromUser(user);
      this.config = {
        ...this.config,
        partnerKey,
        appId: this.kzpService.getAppIdFromPartnerKey(partnerKey),
        user: {
          id: user['@id'],
          email: user.email,
          avatar: user.avatar
            ? (user.avatar as Media).thumbs.small
            : environment.REDIRECT_URL + '/assets/images/register/virgin_profile.png',
          username: user.username,
        },
        menus: {
          profile: [
            {
              text: $localize`:@@kazaplan.menu.discover-community:The community`,
              subtext: $localize`:@@kazaplan.menu.discover-community-sub:share with our members`,
              url: environment.REDIRECT_URL + this.router.createUrlTree(this.localizeRouterService.translateRoute(['kazacafe']) as string[]),
              icon: environment.REDIRECT_URL + '/assets/images/icons/kazaplan/kazacafe.svg',
            },
            {
              text: $localize`:@@kazaplan.menu.my-kaza:My kaza`,
              subtext: $localize`:@@kazaplan.menu.my-kaza-sub:the space of my project`,
              url: environment.REDIRECT_URL + this.router.createUrlTree(this.localizeRouterService.translateRoute(['kaza', convertIRItoID(user.activeKaza['@id']), 'story']) as string[]),
              icon: environment.REDIRECT_URL + '/assets/images/icons/kazaplan/kaza-menu.svg',
            }, {
              text: $localize`:@@kazaplan.menu.profile:MY PROFILE`,
              subtext: $localize`:@@kazaplan.menu.profile-sub:My personal information`,
              url: environment.REDIRECT_URL + this.router.createUrlTree(this.localizeRouterService.translateRoute(['profile', convertIRItoID(user['@id']), 'infos']) as string[]),
              icon: environment.REDIRECT_URL + '/assets/images/icons/menu/profil.svg',
            },
          ],
        },
        kazaFirstPlan: (typeof user.activeKaza !== 'string' && user.activeKaza && user.activeKaza.mainPlan) ? false : true,
      };

      Sentry.addBreadcrumb({
        category: 'console',
        message: 'Kzp cmp > loadUser > userStore > currentUser > ' + user,
        level: 'info',
      });

      Sentry.setUser({email: user.email, id: user['@id'], username: user.username});

      this.cdr.detectChanges();

      if (this.userStoreService.isPro) {
        return this.userStoreService.userStoreProfessional
          .pipe(
            filterUndefined(),
            tap((pro: Professional) => {
              if (pro) {
                this.config.user.avatar = pro.avatar
                  ? pro.avatar.contentUrl
                  : environment.REDIRECT_URL + '/assets/images/register/virgin_profile.png';
                this.cdr.detectChanges();
              }
            }),
          );
      } else {
        return of(true);
      }
    } else {

      const partnerKey = this.kzpService.getPartnerKeyFromCookie();
      this.config = {
        ...this.config,
        partnerKey,
        appId: this.kzpService.getAppIdFromPartnerKey(partnerKey),
      };

      return of(true);
    }
  }

  loadUser(): Observable<any> {
    return this.userStoreService.userStore.pipe(
      filterUndefined(),
      distinctHydraMember(),
      switchMap((user) => {
        return this.initUser(user);
      }),
    );
  }

  loadPlan(): Observable<any> {
    const kazaplan = this.activatedRoute.snapshot.data.kazaplan;

    return zip(this.userStoreService.userStore.pipe(
      filterUndefined(),
    ), of(kazaplan)).pipe(
      tap(
        ([user, plan]) => {
          this.userLoggedIsAdmin = this.userStoreService.isAdmin;
          const isAuthorOrAdmin: boolean = (plan !== null && plan.userId !== null && user !== null &&
            plan.userId === parseInt(user.kazaplanId)) || this.userLoggedIsAdmin;
        }),
      switchMap(([user, plan]) => {
        if (isPlatformBrowser(this.platformId)) {
          this.doc.body.classList.add('kz-app-kazaplan');

          Sentry.addBreadcrumb({
            category: 'console',
            message: 'Kzp cmp > loadPlan > switchMap',
            level: 'info',
          });

          return this.initUser(user).pipe(
            switchMap(() => of(plan)),
          );
        }
        return of(plan);
      }));
  }

  private extractTemplateFromRouter(router: Router): string {
    let child = router.routerState.root.firstChild;
    const components = [];
    while (child) {
      if (child.routeConfig && child.routeConfig.path) {
        components.push(child.routeConfig.path);
      }
      child = child.firstChild;
    }
    return `/${components.join('/')}`;
  }

  loadAuthModule(): void {
    // Load chunck for auth module to prevent erreur with next deploy
    import('../auth/auth.module').then(() => {
    });
  }

  savePlan(planId: number, title: string, projectId: number, redirection: string) {
    this.planNew = false;
    this.planSaved = true;
    this.cdr.detectChanges();
    this.dataLayerService.sendEvent(
      {event: 'kazaplanSave', eventCategory: 'kazaplan', eventAction: GAEventAction.SAVE, eventLabel: `${planId}`});

    if (projectId == null) {
      this.projectSubscription =
      this.kazaPlanService.updatePlan(planId.toString(),{projectId:this.userStoreService.userActiveKaza.projectId})
        .subscribe();
    }

    if (redirection !== null) {
      this.exitPlan(redirection);
    } else if (this.skipAlertMessageOnExit) {
      this.exitPlan(this.exitUrl);
    }

    if (this.planId === planId) {
      return;
    }

    this.planId = planId;

    const editPath = (this.localizeRouterService.translateRoute(['kazaplan', planId, 'edit']) as string[]).join('/');
    window.history.pushState({}, null, editPath);

    if (redirection !== null) {
      this.exitPlan(redirection);
      return NEVER;
    } else if (this.exitUrl !== null && this.exitUrl !== 'null' && this.skipAlertMessageOnExit) {
      this.exitPlan(this.exitUrl);
      return NEVER;
    } else {
      return NEVER;
    }
  }

  exitPlan(url: string) {
    // TODO : why don't use : this.kazaplanInstance.apiUserExit(url);
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = `${environment.REDIRECT_URL}${url}`;
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  alertBeforeLeavingKazaplan($event) {
    if (this.browserIsValid && !this.skipAlertMessageOnExit) {
      const alertMessage = $localize`:@@toast.change_may_not_be_saved:Changes you have made may not be saved.`;
      $event = $event || window.event;

      if ($event) {
        $event.returnValue = alertMessage;
      }
      return alertMessage;
    } else {
      return null;
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    if (this.browserIsValid && !this.routesService.routeHasOutlet('auth')) {
      const key = event.key || event.code;
      if (key === 'a' || key === 'b' || key === '65' || key === '66') {
        this.shortCuts[key] = event.type === 'keydown';
      }

      if ((this.shortCuts.a && this.shortCuts.b) || (this.shortCuts['65'] && this.shortCuts['66'])) {
        event.preventDefault();
      }
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }

    if (this.tokySub && !this.tokySub.closed) {
      this.tokySub.unsubscribe();
    }

    if (this.createPlanSubscriber && !this.createPlanSubscriber.closed) {
      this.createPlanSubscriber.unsubscribe();
    }

    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }

    if (this.projectSubscription && !this.projectSubscription.closed) {
      this.projectSubscription.unsubscribe();
    }

    if (isPlatformBrowser(this.platformId)) {
      this.doc.body.classList.remove('kz-app-kazaplan');
    }
  }

  closeReadOnlyModal() {
    this.isReadOnlyModalClosed = true;
    this.cdr.markForCheck();
  }
}


